import get from "lodash/get";
import TokenManager from "utils/TokenManager";
import Toaster from "components/Toaster";
import { store } from "store";
import { SSO_SESSION_EXPIRED } from "reducers/ssoSessionExpired";
import { ssoTabSync } from "utils/ssoTabSync";
import { clearApplicationAnnouncementSession } from "utils/applicationAnnouncementStorage";
import { syncUserSettings } from "./ux";

export const clearRedux = () => {
  store.dispatch({ type: "DESTROY_SESSION" });
};

export const logout = (forceLogout) => {
  /* Set current tab data */

  const isAuthPage = ["/login", "/sso-login"].includes(
    window.location.pathname
  );

  if (!isAuthPage) {
    window.sessionStorage.removeItem("client_id_context");
    window.sessionStorage.removeItem("client_customer_rel_id_context");
  }

  if (
    window.location.href.includes("token") &&
    window.location.href.includes("redirect")
  ) {
    localStorage.setItem("loginURL", window.location.href); // store login link
  }

  const clearAndRedirect = () => {
    // Set other open tabs data
    window.localStorage.setItem("loggedout", TokenManager.getUserId());
    clearApplicationAnnouncementSession();
    const loginUrl = localStorage.getItem("loginURL");
    if (TokenManager.isPingAuthorizationEnabled()) {
      // For SSO/Ping users: show session-expired modal so the user can
      // re-authenticate via signinRedirect instead of doing a full signout.
      const userEmail = TokenManager.getUserEmail();
      // Clear the OIDC user in every other open tab's sessionStorage too
      ssoTabSync.broadcastLogout();
      store.dispatch({
        type: SSO_SESSION_EXPIRED,
        payload: { userEmail },
      });
      return;
    }
    localStorage.clear();
    // for clearing redux persist data
    setTimeout(() => {
      if (loginUrl) {
        window.open(loginUrl, "_self");
      } else {
        !isAuthPage && window.open(`${window.location.origin}/login`, "_self");
      }
      setTimeout(clearRedux, 100);
    }, 100);
  };

  /* Save current path in UX api */
  if (forceLogout) {
    clearAndRedirect();
    return;
  }
  // Cap the sync wait so a slow/hanging request can never block the logout redirect
  const SYNC_TIMEOUT_MS = 3000;
  const syncTimeout = new Promise((resolve) =>
    setTimeout(resolve, SYNC_TIMEOUT_MS)
  );
  Promise.race([syncUserSettings(false), syncTimeout])
    .then(clearAndRedirect)
    .catch(clearAndRedirect);
};

export const handleAPIError = (e, display_error = false, setisFetching) => {
  // "Request failed with status code 401"
  setisFetching && setisFetching(false);
  const error_message = get(e, "message", "");
  if (display_error && error_message && typeof error_message === "string")
    Toaster(error_message, "error");
  if (get(e, "status", "") === 401) {
    logout(true);
  }
};
